var map = {
	"./en.ts": [
		"./src/assets/i18n/en.ts"
	],
	"./pt_br.ts": [
		"./src/assets/i18n/pt_br.ts",
		0
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/assets/i18n lazy recursive ^\\.\\/.*\\.ts$";
module.exports = webpackAsyncContext;